import { render, staticRenderFns } from "./report-gross-profit.vue?vue&type=template&id=71dfddc2&scoped=true&"
import script from "./report-gross-profit.vue?vue&type=script&lang=ts&"
export * from "./report-gross-profit.vue?vue&type=script&lang=ts&"
import style0 from "./report-gross-profit.vue?vue&type=style&index=0&id=71dfddc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dfddc2",
  null
  
)

export default component.exports